module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PanelHeading', {
    attrs: {
      "title": "Lecture notes imported",
      "subtitle": "Your notes were imported successfully. Where to now?"
    }
  }), _vm._v(" "), _vm._c('PanelBody', [_vm._c('div', {
    staticClass: "row ptb-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('router-link', {
    staticClass: "btn btn-primary btn-xl xs-mr-20 sm-mr-50",
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._v("Return to subject shelf")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "import-link",
    attrs: {
      "to": {
        name: 'importer'
      }
    }
  }, [_vm._v("Import another file")])], 1)]), _vm._v(" "), (_vm.showSummary) ? _vm._c('div', {
    staticClass: "row ptb-50 xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('h3', [_vm._v("Import summary")]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Subjects added:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.subjects_added))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Subjects skipped:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.subjects_skipped))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Chapters added:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.chapters_added))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Chapters skipped:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.chapters_skipped))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Micronotes added:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.micronotes_added))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "summary-row"
  }, [_vm._c('strong', {
    staticClass: "summary-name pull-left"
  }, [_vm._v("Micronotes skipped:")]), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.micronotes_skipped))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e()])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b40dc9a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-importer/MicroNoteImportSuccess.vue
// module id = 707
// module chunks = 1